import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {trigger} from '@angular/animations';
import {smoothEnterLeaveAnimation} from '../../../../shared/animations/custom-animations';
import {ForgotPasswordService} from '../../../services/forgot-password.service';
import * as OtpOptions from '../../../../shared/constants/otp-options.const';
import { DomainNameParserService } from 'src/main/resources/static/angular2/app/shared/services/domain-name-parser.service';
import { PHONE_NUMBER_LIST } from 'src/main/resources/static/angular2/app/shared/constants/phone-numbers.const';

@Component({
  selector: 'app-send-confirmation-code-by-email',
  templateUrl: './send-confirmation-code-by-email.component.html',
  styleUrls: [
    './send-confirmation-code-by-email.component.css',
    '../../../../../assets/css/floating-labels.css',
  ],
  animations: [
    trigger('showSendVerificationEmailButton', smoothEnterLeaveAnimation('100ms 150ms', '100ms')),
    trigger('showConfirmationCodeWindow', smoothEnterLeaveAnimation('100ms 150ms', '100ms'))
  ]
})
export class SendConfirmationCodeByEmailComponent implements OnInit {

  sendVerificationEmailButtonClicked = false;
  verificationEmailRequestSent = false;
  serverErrorMessageShown = false;
  customerServicePhone;

  resetPasswordByEmailForm = new FormGroup({
    usernameInput: new FormControl('', [
      Validators.required
    ]),
    emailInput: new FormControl('', [
      Validators.required,
      Validators.email
    ])
  });

  constructor(private forgotPasswordService: ForgotPasswordService,
              private domainNameParserService: DomainNameParserService) {
    this.customerServicePhone = PHONE_NUMBER_LIST[this.domainNameParserService.getState()];
  }

  ngOnInit(): void {
  }

  setUsernameInput(username: string): void {
    this.resetPasswordByEmailForm.controls.usernameInput.setValue(username);
  }

  getUsernameValue(): string {
    return this.resetPasswordByEmailForm.controls.usernameInput.value;
  }

  setEmailInput(email: string): void {
    this.resetPasswordByEmailForm.controls.emailInput.setValue(email);
  }

  getEmailValue(): string {
    return this.resetPasswordByEmailForm.controls.emailInput.value;
  }

  resetPasswordByEmail(): void {
    this.resetErrorsShown();
    this.sendVerificationEmailButtonClicked = true;
    if (!this.resetPasswordByEmailForm.valid) {
      return;
    }

    this.forgotPasswordService.requestOneTimePassword(this.getUsernameValue(), OtpOptions.EMAIL_OTP_OPTION,
      this.getEmailValue()).subscribe(_ => {
      console.log('Resetting password by email...');
      this.verificationEmailRequestSent = true;
    },
    error => {
      this.showServerErrorMessage();
    });
  }

  private showServerErrorMessage(): void {
    this.serverErrorMessageShown = true;
  }

  private resetErrorsShown(): void {
    this.serverErrorMessageShown = false;
  }
}
